const controllers = {
  home: require('./views/home'),
  about: require('./views/about'),
  services: require('./views/services'),
  servicesShow: require('./views/servicesShow'),
  contact: require('./views/contact'),
  blogSingle: require('./views/blog-single'),
}

export default controllers
